import DropdownComponent from 'components/Widgets/Dropdown/DropdownComponent';
import { useEffect, useState } from 'react';
import { getAllTypeIcons } from 'services/typeSampleSource.services';
import baseClasses from '../../../../WorkRightUsersDir/WorkRightUserAddMenu/workRightUserAddMenu.module.css';
import classes from '../TypeSampleSourceForm.module.css';
import error from '../../../../../../assets/svg/attention-01.svg';
import { address_server_short, PUBLIC_ASSETS } from '../../../../../../config';
import classNames from 'classnames';

const DefaultFields = ({
  isClickAdd,
  mode,
  typeSampleSourceSelected,
  setTypeSampleSourceField,
}) => {
  const [icons, setIcons] = useState([]);
  const [folders, setFolders] = useState([]);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    const loadAllFolders = async () => {
      let allFolders = await getAllTypeIcons();
      let arreyOfFolders = allFolders?.result?.data?.map((obj) => {
        const firstKey = Object.keys(obj)[0];
        return obj[firstKey];
      });

      if (allFolders.success) {
        setFolders(arreyOfFolders);

        if (typeSampleSourceSelected?.icon == null) {
          if (typeSampleSourceSelected.folder == null) {
            setTypeSampleSourceField(
              'folder',
              arreyOfFolders.map((i) => ({ id: i, name: i }))[0].name,
            );
          }
        } else {
          setTypeSampleSourceField('folder', typeSampleSourceSelected.icon.split('/')[2]);
        }
      } else
        mode.Widget.setWidget({
          status: 'Error',
          text: 'Наборы картинок не найдены',
          fun: async () => {},
        });
    };

    loadAllFolders();
  }, []);

  useEffect(() => {
    loadAllTypeIcons();
  }, [typeSampleSourceSelected.folder]);

  const loadAllTypeIcons = async () => {
    let res = await getAllTypeIcons(typeSampleSourceSelected.folder);
    let arreyOfIcons = res.result.data[0].icons;

    if (res.success) {
      setIcons(arreyOfIcons);
    } else
      mode.Widget.setWidget({
        status: 'Error',
        text: 'Данные по картинкам не найдены',
        fun: async () => {},
      });
  };

  return (
    <>
      <div className={classNames(classes.dropDown_container, classes.iconsFormContainer)}>
        <div className={classes.lable}>
          Набор <br />
          картинок
        </div>
        <div className={classes.dropDown}>
          <DropdownComponent
            key={'folders_1'}
            selectedKey={typeSampleSourceSelected?.folder}
            items={folders.map((i) => ({ id: i, name: i }))}
            onChange={(val) => setTypeSampleSourceField('folder', val)}
          />
        </div>
      </div>
      {icons != undefined && (
        <div className={classes.iconsContainer}>
          {icons.map((iconUrl, index) => (
            <div
              key={index}
              className={
                (iconUrl === typeSampleSourceSelected?.icon ? classes.bg_blue : '') +
                ' ' +
                classes.itemIcon
              }
              onClick={() => setTypeSampleSourceField('icon', iconUrl)}
            >
              <div className={classes.containerImg}>
                <img
                  src={address_server_short + PUBLIC_ASSETS + iconUrl}
                  className={classes.itemImg}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {typeSampleSourceSelected?.icon == null && isClickAdd && (
        <div className={baseClasses.dataErrorBlock}>
          <img src={error} alt={'error'} />
          <div className={baseClasses.dataError}>Выбор картинки обязателен</div>
        </div>
      )}
      <div className={classes.dropDown_container}>
        <div className={classes.lable}>
          Название типа <br />
          источника
        </div>
        <div className={classes.inputContainer}>
          <input
            className={classes.input}
            value={typeSampleSourceSelected.name ?? ''}
            onChange={(e) => setTypeSampleSourceField('name', e.target.value)}
            type="text"
            placeholder="Введите название..."
          />
        </div>
      </div>
      {!typeSampleSourceSelected?.name?.trim() && isClickAdd && (
        <div className={baseClasses.dataErrorBlock}>
          <img src={error} alt={'error'} />
          <div className={baseClasses.dataError}>Поле обязательно для заполнения</div>
        </div>
      )}
      <div className={classes.dropDown_container}>
        <div className={classes.lable}>Описание</div>
        <div className={classes.dropDown}>
          <textarea
            className={classes.textarea}
            placeholder={'Описание объекта'}
            value={typeSampleSourceSelected.description ?? ''}
            onChange={(val) => setTypeSampleSourceField('description', val.target.value)}
          ></textarea>
        </div>
      </div>
      {!typeSampleSourceSelected?.description?.trim() && isClickAdd && (
        <div className={baseClasses.dataErrorBlock}>
          <img src={error} alt={'error'} />
          <div className={baseClasses.dataError}>Поле обязательно для заполнения</div>
        </div>
      )}
    </>
  );
};

export default DefaultFields;
